import React, { useEffect, useState } from "react";
import QuestionCard from "../cards/questionCard/QuestionCard";
import BlogsCard from "../cards/blogsCard/BlogsCard";
import "./timeline.css";
import axios from "axios";
import API_ENDPOINT from "../wm.api.service";
import { decode } from "base-64";
import Cookies from "universal-cookie";
import { Link, useHistory } from "react-router-dom";
import Skeleton from "@material-ui/lab/Skeleton";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import EditComment from "../Components/EditComments/EditComment";
import EditAnswer from "../Components/EditAnswer/EditAnswer";
import { connect } from "react-redux";
import Pagination from "react-js-pagination";
const cookies = new Cookies();

function PostTimeline({ rootData }) {
  if (cookies.get("wmusers")) {
    var user = decode(cookies.get("wmusers"));
  } else {
    var user = 'members';
  }
  var token = cookies.get("wmtoken");
  let history = useHistory();
  const hash = history.location.hash.substring(1)
  const [posts, setPosts] = useState("");
  const [activeVal, setActiveVal] = useState(1)
  const [tabIndex, setTabIndex] = useState('')


  const [questionData, setQuestionData] = useState([])
  const [questionPageNo, setQuestionPageNo] = useState(0);
  const [totalQuestionCount, setTotalQuestionCount] = useState(0)
  const [isQuestionLoadig, setIsQuestionLoading] = useState(false)

  const [blogData, setBlogData] = useState([])
  const [blogPageNo, setBlogpageNo] = useState(0)
  const [totalBlogCount, setTotalBlogCount] = useState(0)
  const [isBlogLoading, setIsBlogLoading] = useState(false)

  const [commentData, setCommentData] = useState([])
  const [commentPageNo, setCommentPageNo] = useState(0)
  const [totalCommentCount, setTotalCommentCount] = useState(0)
  const [isCommentLoading, setCommentLoading] = useState(false)

  const [answerData, setAnswerData] = useState([])
  const [answerPageNo, setanswerPageNo] = useState(0)
  const [totalanswerCount, setTotalanswerCount] = useState(0)
  const [isanswerLoading, setanswerLoading] = useState(false)

  useEffect(() => {
    if (rootData.user.username) {
      if (hash === 'blogs') {
        setIsBlogLoading(true)
        getPostData('BLOG', blogPageNo)
        setTabIndex(2)
      } else if (hash === 'questions') {
        setIsQuestionLoading(true)
        getPostData('QUESTION', questionPageNo)
        setTabIndex(1)
      } else if (hash === 'comments') {
        setCommentLoading(true)
        getOnlySpecificContent('COMMENT', commentPageNo)
        setTabIndex(3)
      } else if (hash === 'answer') {
        setanswerLoading(true)
        getOnlySpecificContent('ANSWER', answerPageNo)
        setTabIndex(4)
      } else {
        getPostData('ALL', 0)
        setTabIndex(0)
      }
    }
  }, [rootData.user.username, questionPageNo, blogPageNo, commentPageNo, answerPageNo, hash]);

  const getPostData = (screen, pageno = 1) => {
    setActiveVal(pageno)
    if (token) {
      var fd = new FormData();
      fd.append('username', rootData.user?.username)
      fd.append('screen', screen)
      fd.append('page_no', pageno)
      axios({
        method: "post", url: `${API_ENDPOINT.apiURL}Profile/getUserPostData`, data: fd,
      })
        .then(function (response) {
          if (hash === 'blogs') {
            setBlogData(response.data.post_data)
            setTotalBlogCount(response.data.count)
            setIsBlogLoading(false)
          } else if (hash === 'questions') {
            setQuestionData(response.data.post_data)
            setTotalQuestionCount(response.data.count)
            setIsQuestionLoading(false)
          } else {
            setPosts(response.data.post_data);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    }
  };
  const backToLoginPage = () => {
    history.push("/login");
  };
  const getOnlySpecificContent = (screenName, pageNo) => {
    if (token) {
      var fd = new FormData();
      fd.append("token", decode(token));
      fd.append("identity", "wmhandler");
      fd.append("screen_name", screenName);
      fd.append("page_no", pageNo);
      axios({
        method: "post",
        url: `${API_ENDPOINT.apiURL}Profile/getUserComments`,
        data: fd,
      })
        .then(function (response) {
          if (screenName === "COMMENT") {
            setTotalCommentCount(response.data.count)
            setCommentData(response.data.data)
            setCommentLoading(false)
            console.log(response.data.data)
          }
          if (screenName === "ANSWER") {
            setTotalanswerCount(response.data.count)
            setAnswerData(response.data.data)
            setanswerLoading(false)
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    }
  };

  const handlepageNum = (pagenum, screen) => {
    if (screen === 'blogs') {
      setBlogpageNo(pagenum - 1)
      setIsBlogLoading(true)
    } else if (screen === 'questions') {
      setQuestionPageNo(pagenum - 1)
      setIsQuestionLoading(true)
    } else if (screen === 'comments') {
      setCommentLoading(true)
      setCommentPageNo(pagenum - 1)
    } else if (screen === 'answer') {
      setanswerLoading(true)
      setanswerPageNo(pagenum - 1)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [rootData.user.username, questionPageNo, blogPageNo, commentPageNo, answerPageNo, hash])
  return (
    <React.Fragment>
      {token ? (
        <div className="timeLineContainer">
          <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <TabList className="w-100 flex overflow-auto justify-start md:justify-center postList border-b border-gray-300 border-solid md:border-b-0">
                    {user === 'members' && <Tab className="text-gray-400 px-3 md:px-4 cursor-pointer text-center mb-2 relative manpro font-semibold text-xl">
                      <Link className="text-gray-400 no-underline hover:text-gray-800" to={`/posts#all`}>All</Link>
                    </Tab>}
                    {user === 'members' && <Tab className="text-gray-400 px-3 md:px-4 cursor-pointer text-center mb-2 relative manpro font-semibold text-xl">
                      <Link className="text-gray-400 no-underline hover:text-gray-800" to={`/posts#questions`}>Questions</Link>
                    </Tab>}
                    <Tab className="text-gray-400 px-3 md:px-4 cursor-pointer text-center mb-2 relative manpro font-semibold text-xl">
                      <Link className="text-gray-400 no-underline hover:text-gray-800" to={`/posts#blogs`}>Blogs</Link>
                    </Tab>
                    <Tab className="text-gray-400 px-3 md:px-4 cursor-pointer text-center mb-2 relative manpro font-semibold text-xl">
                      <Link className="text-gray-400 no-underline hover:text-gray-800" to={`/posts#comments`}>Comments</Link>
                    </Tab>
                    {user === 'members' && <Tab className="text-gray-400 px-3 md:px-4 cursor-pointer text-center mb-2 relative manpro font-semibold text-xl">
                      <Link className="text-gray-400 no-underline hover:text-gray-800" to={`/posts#answer`}>Answers</Link>
                    </Tab>}
                  </TabList>
                </div>
                <div className="col-md-12">
                  <TabPanel>
                    <div className="container-fluid px-0">
                      <div className="row">
                        <div className="col-md-12">
                          {posts.questions ? (
                            posts.questions?.slice(0, 6).map((question_data, idx) => {
                              return (<QuestionCard key={idx} question_data={question_data}/>);
                            })
                          ) : (
                            <React.Fragment>
                              <Skeleton variant="rect" className="mb-4" height={118}/>
                              <Skeleton variant="rect" className="mb-4" height={118}/>
                            </React.Fragment>
                          )}
                        </div>
                        <div className="col-md-12 pb-12">
                          <div className="row">
                            {posts.blog ? (
                              posts.blog?.slice(0, 6).map((blog_data, idx) => {
                                return (<div key={idx} className="col-md-4 col-lg-4"><BlogsCard blog_data={blog_data} /></div>);
                              })
                            ) : (
                              <React.Fragment>
                                <div className="col-md-4 col-lg-4">
                                  <Skeleton variant="rect" className="mb-4" height={418}/>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <Skeleton variant="rect" className="mb-4" height={418}/>
                                </div>
                                <div className="col-md-4 col-lg-4">
                                  <Skeleton variant="rect" className="mb-4" height={418}/>
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="container-fluid px-0">
                      <div className="row">
                        <div className="col-md-12">
                          {!isQuestionLoadig ? (
                            <>
                              {questionData?.map((question_data, idx) => {return (<QuestionCard key={idx} question_data={question_data} />);})}
                              {totalQuestionCount > 10 && <div className="col-md-12 mb-8">
                                <div className="pagination--container flex items-center justify-center">
                                  <Pagination activePage={questionPageNo + 1} itemsCountPerPage={10} totalItemsCount={totalQuestionCount} pageRangeDisplayed={3} hideNavigation={true} onChange={(page) => handlepageNum(page, 'questions')}
                                    hideDisabled
                                    innerClass={`flex space-x-4 overflow-auto`}
                                    itemClass={`bg-gray-200 rounded-md text-gray-700 cursor-pointer`}
                                    linkClass={`px-4 py-2 inline-block`}
                                    activeClass={`active-li`}
                                    activeLinkClass={`text-gray-100`}
                                  />
                                </div>
                              </div>}
                            </>
                          ) : (
                            <React.Fragment>
                              <Skeleton variant="rect" className="mb-4" height={118} />
                              <Skeleton variant="rect" className="mb-4" height={118} />
                            </React.Fragment>
                          )}
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="container-fluid px-0">
                      <div className="row">
                        <div className="col-md-12 pb-12">
                          <div className="row">
                            {!isBlogLoading ? (
                              <>
                                {
                                  blogData?.map((blog_data, idx) => {
                                    return (
                                      <div key={idx} className="col-lg-4">
                                        <BlogsCard blog_data={blog_data} />
                                      </div>
                                    );
                                  })
                                }
                                {totalBlogCount > 6 && <div className="col-md-12 mb-8">
                                  <div className="pagination--container flex items-center justify-center">
                                    <Pagination
                                      activePage={blogPageNo + 1}
                                      itemsCountPerPage={6}
                                      totalItemsCount={totalBlogCount}
                                      pageRangeDisplayed={3}
                                      hideNavigation={true}
                                      onChange={(page) => handlepageNum(page, 'blogs')}
                                      hideDisabled
                                      innerClass={`flex space-x-4 overflow-auto`}
                                      itemClass={`bg-gray-200 rounded-md text-gray-700 cursor-pointer`}
                                      linkClass={`px-4 py-2 inline-block`}
                                      activeClass={`active-li`}
                                      activeLinkClass={`text-gray-100`}
                                    />
                                  </div>
                                </div>}</>
                            ) : (
                              <React.Fragment>
                                <div className="col-lg-4">
                                  <Skeleton variant="rect" className="mb-4" height={418} />
                                </div>
                                <div className="col-lg-4">
                                  <Skeleton variant="rect" className="mb-4" height={418} />
                                </div>
                                <div className="col-lg-4">
                                  <Skeleton variant="rect" className="mb-4" height={418} />
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="container-fluid px-0">
                      <div className="row">
                        <div className="col-md-12 pb-12">
                          <div className="row">
                            {!isCommentLoading ? <>
                              {commentData.map((commentData) => {
                                return <EditComment key={commentData.comment_id} commentData={commentData} getOnlySpecificContent={getOnlySpecificContent} />
                              })}
                              {totalCommentCount > 10 && <div className="col-md-12 mb-8">
                                <div className="pagination--container flex items-center justify-center">
                                  <Pagination
                                    activePage={commentPageNo + 1}
                                    itemsCountPerPage={10}
                                    totalItemsCount={totalCommentCount}
                                    pageRangeDisplayed={3}
                                    hideNavigation={true}
                                    onChange={(page) => handlepageNum(page, 'comments')}
                                    hideDisabled
                                    innerClass={`flex space-x-4 overflow-auto`}
                                    itemClass={`bg-gray-200 rounded-md text-gray-700 cursor-pointer`}
                                    linkClass={`px-4 py-2 inline-block`}
                                    activeClass={`active-li`}
                                    activeLinkClass={`text-gray-100`}
                                  />
                                </div>
                              </div>}
                            </> : ''}
                          </div>
                        </div>
                      </div>
                    </div>
                  </TabPanel>
                  <TabPanel>
                    <div className="container-fluid px-0">
                      <div className="row">
                        <div className="col-md-12 pb-12">
                          <div className="row">
                            {!isanswerLoading ? <>
                              {answerData.map((answerData, idx) => {
                                return <EditAnswer key={idx} answerData={answerData} getOnlySpecificContent={getOnlySpecificContent} />
                              })}
                              {totalanswerCount > 10 && <div className="col-md-12 mb-8">
                                <div className="pagination--container flex items-center justify-center">
                                  <Pagination
                                    activePage={totalanswerCount + 1}
                                    itemsCountPerPage={10}
                                    totalItemsCount={totalanswerCount}
                                    pageRangeDisplayed={3}
                                    hideNavigation={true}
                                    onChange={(page) => handlepageNum(page, 'answer')}
                                    hideDisabled
                                    innerClass={`flex space-x-4 overflow-auto`}
                                    itemClass={`bg-gray-200 rounded-md text-gray-700 cursor-pointer`}
                                    linkClass={`px-4 py-2 inline-block`}
                                    activeClass={`active-li`}
                                    activeLinkClass={`text-gray-100`}
                                  />
                                </div>
                              </div>}
                            </> : ''}
                          </div>
                        </div>

                      </div>
                    </div>
                  </TabPanel>
                </div>
              </div>
            </div>
          </Tabs>
        </div>
      ) : (
        backToLoginPage()
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return state;
};

export default connect(mapStateToProps, null)(PostTimeline);
